import {ChangeEvent, HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {CheckBoxV2} from '../../molecules/CheckBoxV2/CheckBoxV2';

interface DialogCheckProps
  extends HTMLAttributes<Omit<HTMLDivElement, 'onChange'>> {
  isChecked?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export function DialogCheck({
  children,
  isChecked = false,
  onChange,
  className,
  ...props
}: DialogCheckProps) {
  return (
    <div
      className={twMerge('flex items-center justify-center', className)}
      {...props}
    >
      <label className="flex cursor-pointer items-center space-x-8pxr">
        <CheckBoxV2 checked={isChecked} onChange={onChange} />
        <Text className="font-small1 text-theme-solid-100">{children}</Text>
      </label>
    </div>
  );
}

export const DialogCheckType = (<DialogCheck />).type;
